import React, { useEffect, useState } from 'react';
import '../style.css';
import { embeddingAssets } from '../dbNames';
import useGlobal from '../../store';
import server from '../../api/server'

const ManageAssetsConfig = () => {
    const [globalState, globalActions] = useGlobal();
    const [state, setState] = useState({
        status: 'Ready to configure part number',
        input: ['', '']
    });

    useEffect(() => {
        globalActions.getData(embeddingAssets, '{}', globalState.token);
        globalActions.configureAction('configPartNumber', undefined)
    }, []);

    const selectPartNumber = (event) => {
        if (event !== undefined) {
            globalActions.configureAction('configPartNumber', event.target.id);
            setState({ ...state, status: 'Ready to modify asset'  })
        }
    }

    function renderStatus() {
        if (globalState.partNumbers === undefined) {
            return (<p>Return to home</p>)
        } else {
            return (<p>{state.status}</p>);
        }
    }


    function deletePartNumber(event) {
        if (event !== undefined) {
            var confirmation = window.confirm('Are you sure you want to delete?')
            const config = {
                headers: { Authorization: `Bearer ${globalState.token}` }
            };
            if (confirmation === true) {
                console.log(globalState.configPartNumber, globalState.user._id)
                server.delete(`/deleteEmbeddingAssetByOwner/?name=${globalState.configPartNumber}&&owner=${globalState.user._id}`,config)
                    .then((response) => {
                        if (response.status === 200) {
                            setState({ ...state, status: 'Asset successfully deleted' });
                            globalActions.getData(embeddingAssets, '{}', globalState.token);
                            globalActions.configureAction('configPartNumber', undefined)
                        } else {
                            setState({ ...state, status: `Their was an error deleting the Asset` })
                        }

                    }).catch((error) => {
                        var errorCode = parseInt(error.message.slice(error.message.indexOf("code") + 5, error.message.length))
                        var message = `Problem deleting Asset error code: ${errorCode}`
                        setState({ ...state, status: message });
                    });
            }
        }
    }

    function renderDeleteButton() {
        if (globalState.configPartNumber !== 'new') {
            return (
                <div className="button" id="delete" onClick={deletePartNumber}>
                    DELETE
                </div>
            )
        } else {
            return <div></div>
        }
    }

    function renderAssets() {
        if (globalState.embeddingAssets === undefined) {
            return (<div>Loading....</div>)
        } else {
            return (
                <div>
                    <div className="ui message">
                        <h2>
                            Asset Management                            
                        </h2>
                    </div>
                    <div className="grid">
                        <div className="quality1">
                            {globalState.embeddingAssets.map(rt => {
                                var selected = "poContent"
                                if (rt === globalState.configPartNumber) {
                                    selected = "poContent selected";
                                }
                                return (
                                    <div className={selected} id={rt} onClick={selectPartNumber} >
                                        <div className="header" id={rt}>
                                            <i className="industry icon" id={rt}></i>
                                            Name: {rt}
                                        </div>                                        
                                    </div>
                                )
                            })}
                        </div>
                        <div className="editWindow">{renderEditWindow()}</div>
                    </div>
                </div>
            )
        }
    }

    function renderEditWindow() {
        if (globalState.configPartNumber === undefined) {
            return (<div>Please select an Asset to modify</div>)
        } else {
            return (
                <div>
                    <div className="ui message">
                        <div className="header">
                            Status:
                        </div>
                        {renderStatus()}
                    </div>
                    <div className="grid">
                        <div className="quality1">
                            <div className="spacing">Asset Name:</div>
                            <div className="spacing">{globalState.configPartNumber}</div>
                            {renderDeleteButton()}
                        </div>
                    </div>
                </div>

            )
        }
    }


    return (
        < div >
            {renderAssets()}
        </div >
    )

}

export default ManageAssetsConfig;